const CustomerActionTypes = {
  SET_CUSTOMER: 'SET_CUSTOMER',
  CHANGE_CUSTOMER: 'CHANGE_CUSTOMER',
  RESET_CUSTOMER: 'RESET_CUSTOMER'
};

export default CustomerActionTypes;
